import styled from 'styled-components'
import { Button, type ButtonProps } from '@sevenrooms/ui-kit/form'
import { Icon, type IconType } from '@sevenrooms/ui-kit/icons'
import { Box } from '@sevenrooms/ui-kit/layout'
import { Text } from '@sevenrooms/ui-kit/typography'
import type { CSSProperties, PropsWithChildren } from 'react'

export interface TimeSlotButtonProps extends ButtonProps {
  width?: CSSProperties['width']
  icon?: IconType
}

export function TimeSlotButton({ variant, width = '100%', size, icon, children, ...props }: PropsWithChildren<TimeSlotButtonProps>) {
  const content =
    variant === 'tertiary' ? (
      <Text textStyle="body1Bold" color="primaryFont" textDecoration="underline">
        {children}
      </Text>
    ) : (
      children
    )
  return (
    <StyledButton size={size} noPadding width={width} variant={variant} {...props}>
      {icon && <Icon name={icon} size="lg" />}
      <Box ml={icon ? 'xs' : 'none'}>{content}</Box>
    </StyledButton>
  )
}

const StyledButton = styled(Button)<{ width: CSSProperties['width'] }>`
  width: ${props => props.width};
`
